<template>
  <span class="t-table-v2__sortable">
    <span
      class="t-table-v2__sortable__icon-wrapper"
      :class="{ 't-table-v2__sortable--active': !desc }"
    >
      <t-icon class="t-table-v2__sortable__icon" icon="caret-up" size="lg"/>
    </span>
    <span
      class="t-table-v2__sortable__icon-wrapper"
      :class="{ 't-table-v2__sortable--active': desc }"
    >
      <t-icon icon="caret-down" size="lg"/>
    </span>
  </span>
</template>
<script>
import { TIcon } from '../TIcon';

export default {
  name: 't-table-v2-sortable',
  components: {
    TIcon,
  },
  props: {
    desc: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
